"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
const core = __importStar(require("../../../../core"));
const EventContextSlugs_1 = require("./EventContextSlugs");
const ActionName_1 = require("./ActionName");
const AccountId_1 = require("../../commons/types/AccountId");
const EnvironmentId_1 = require("../../commons/types/EnvironmentId");
const SpaceId_1 = require("../../commons/types/SpaceId");
const WorkbookId_1 = require("../../commons/types/WorkbookId");
const SheetId_1 = require("../../commons/types/SheetId");
const SheetSlug_1 = require("./SheetSlug");
const SnapshotId_1 = require("../../commons/types/SnapshotId");
const VersionId_1 = require("../../commons/types/VersionId");
const CommitId_1 = require("../../commons/types/CommitId");
const JobId_1 = require("../../commons/types/JobId");
const ProgramId_1 = require("../../commons/types/ProgramId");
const FileId_1 = require("../../commons/types/FileId");
const DocumentId_1 = require("../../commons/types/DocumentId");
const EventId_1 = require("../../commons/types/EventId");
const AppId_1 = require("../../commons/types/AppId");
const ActionId_1 = require("../../commons/types/ActionId");
const DataClipId_1 = require("../../commons/types/DataClipId");
exports.Context = core.serialization.object({
    namespaces: core.serialization.list(core.serialization.string()).optional(),
    slugs: EventContextSlugs_1.EventContextSlugs.optional(),
    actionName: ActionName_1.ActionName.optional(),
    accountId: AccountId_1.AccountId,
    environmentId: EnvironmentId_1.EnvironmentId,
    spaceId: SpaceId_1.SpaceId.optional(),
    workbookId: WorkbookId_1.WorkbookId.optional(),
    sheetId: SheetId_1.SheetId.optional(),
    sheetSlug: SheetSlug_1.SheetSlug.optional(),
    snapshotId: SnapshotId_1.SnapshotId.optional(),
    versionId: VersionId_1.VersionId.optional(),
    commitId: CommitId_1.CommitId.optional(),
    jobId: JobId_1.JobId.optional(),
    programId: ProgramId_1.ProgramId.optional(),
    fileId: FileId_1.FileId.optional(),
    documentId: DocumentId_1.DocumentId.optional(),
    precedingEventId: EventId_1.EventId.optional(),
    actorId: core.serialization.string().optional(),
    appId: AppId_1.AppId.optional(),
    actionId: ActionId_1.ActionId.optional(),
    dataClipId: DataClipId_1.DataClipId.optional(),
});
